import { CardItem, IconScalePaws } from '@presentation/components';
import { QUIZ_RESULTS_TOOLTIP_ID } from '@presentation/pages/QuizResults';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbBellRinging } from 'react-icons/tb';
import { ContentTitle } from '../CardItem/styled';
import * as Styled from './styled';
import type { CardItemBreedQuizResultProps } from './types';

export * from './types';

export const CardItemBreedQuizResult: FC<CardItemBreedQuizResultProps> = (props) => {
  const {
    image,
    translatedName,
    name,
    attributes,
    matchPercentage,
    littersLink,
    breedersLink,
    infoLink,
    isSubscribed,
    onSubscribeClick,
    ...rest
  } = props;
  const { translate } = useTranslation();

  return (
    <CardItem
      image={image}
      hideHoverOverlay
      footer={
        <div>
          {infoLink && (
            <Styled.FooterLink target="_blank" to={infoLink}>
              {translate('common.buttons.details')}
            </Styled.FooterLink>
          )}
          {littersLink && (
            <Styled.FooterLink target="_blank" to={littersLink}>
              {translate('common.buttons.seeLitters')}
            </Styled.FooterLink>
          )}
          {breedersLink && (
            <Styled.FooterLink target="_blank" to={breedersLink}>
              {translate('common.buttons.seeBreedings')}
            </Styled.FooterLink>
          )}
        </div>
      }
      {...rest}
    >
      <Styled.TitleSubscribeWrapper>
        <ContentTitle>{translatedName}</ContentTitle>

        <Styled.SubscribeIcon
          active={isSubscribed}
          onClick={onSubscribeClick}
          data-tooltip-id={QUIZ_RESULTS_TOOLTIP_ID}
          data-tooltip-html={
            isSubscribed
              ? translate(
                  'common.sections.breedInterestSubscription.alreadySubscribedToBreedTooltip',
                )
              : translate('common.sections.breedInterestSubscription.subscribeToBreedTooltip')
          }
        >
          <TbBellRinging size={20} />
        </Styled.SubscribeIcon>
      </Styled.TitleSubscribeWrapper>
      <Styled.Container>
        {Object.keys(attributes ?? {})
          .filter((key) => attributes?.[key as keyof typeof attributes] != null)
          .map((key, index) => (
            <Styled.Wrapper key={index}>
              <Styled.Label>{translate(`glossary.breedInfo.${key}.title`)}</Styled.Label>
              <Styled.Value>
                <IconScalePaws
                  amount={attributes?.[key as keyof typeof attributes] ?? 0}
                  maxAmount={3}
                />
              </Styled.Value>
            </Styled.Wrapper>
          ))}
      </Styled.Container>
      <Styled.MatchText>
        {translate('glossary.matching')}
        {': '}
        {Number(matchPercentage).toLocaleString(undefined, {
          style: 'percent',
          maximumFractionDigits: 0,
        })}
      </Styled.MatchText>
    </CardItem>
  );
};
